<template>
    <form-container headerText="Protest in Spiel ändern" :width="650" :action="'protestAendern'+spiel.id"
                    :valid-actions="['protestAendern'+spiel.id]" @save="save" v-if="spiel">
        <div class="px-7 mb-3">
            <v-row no-gutters>
                <v-col sm="6" cols="12">
                    <div class="subtitle-2 mb-3">Heimmannschaft</div>
                    <div>
                        <v-checkbox v-model="result.heim.protest"
                                    hide-details class="pa-0 mb-3 text-right"
                                    label="Protest eingelegt"></v-checkbox>
                    </div>
                </v-col>
                <v-col sm="6" cols="12">
                    <div class="subtitle-2 mb-3">Gastmannschaft</div>
                    <div>
                        <v-checkbox v-model="result.gast.protest"
                                    hide-details class="pa-0 mb-3 text-right"
                                    label="Protest eingelegt"></v-checkbox>
                    </div>
                </v-col>
            </v-row>
        </div>
    </form-container>
</template>

<script>
    import {db} from "../../../services/db";
    import FormContainer from "../../../components/form/formContainer";
    import {FormRules} from "../../../services/formRules";

    export default {
        components: {FormContainer},
        name: "spiel-berichte-protest-aendern",
        props: ['spiel'],
        computed: {
            user(){ return this.$store.state.user; }
        },
        data: () => ({
            result: {
                heim: {
                    protest: false,
                },
                gast: {
                    protest: false,
                },
            },
            rules: null,
        }),
        created(){
            if ( this.spiel ) { this.setCurrent() }
            this.rules = new FormRules()
        },
        methods: {
            setCurrent(){
                this.result.heim.protest = this.spiel.heim.protest === undefined ? false : this.spiel.heim.protest;
                this.result.gast.protest = this.spiel.gast.protest === undefined ? false : this.spiel.gast.protest;
            },
            save(){
                this.$store.state.loader = true;
                const updateDocument = this.getUpdateDocument();
                db.collection("spiele").doc(this.spiel.id).update(updateDocument)
                    .then(() => {
                        console.log("Document successfully updated!");
                        this.$store.state.loader = true;
                        window.history.back();
                    })
                    .catch((error) => {
                        console.error("Error updating document: ", error);
                        this.$store.state.loader = true;
                    });
            },
                getUpdateDocument(){
                    return {
                        ['heim.protest']: this.result.heim.protest,
                        ['gast.protest']: this.result.gast.protest,
                    };
                }
        },
        watch: {
            spiel(){ this.setCurrent(); }
        }
    }
</script>

<style scoped>

</style>